import React, { useEffect } from 'react';
import styled from 'styled-components';

import { DeleteOutlined, DownloadOutlined } from '@ant-design/icons';
import { CSVLink } from 'react-csv';
import Button from 'components/forms/Button';
import Tooltip from 'components/Tooltip';

const StickyFooter = styled.div`
    position: fixed;
    bottom: 0;
    left: 50%;
    transform: translate(-50%, 0%);

    display: flex;
    justify-content: space-evenly;
    align-items: center;
    height: 7.5em;
    width: 20em;

    border: 0.1em solid #eaeaea;
    border-radius: 0.2em;
    background-color: white;
    box-shadow: 0 0.2em 0.4em 0 rgba(215, 215, 215, 0.5);
`;

const ReducedFormActions = ({ clearForm, csvData, exportedFileName }) => {
    useEffect(
        () => () => {
            clearForm();
        },
        [],
    );

    return (
        <StickyFooter>
            <div>
                <CSVLink data={csvData} filename={exportedFileName}>
                    <Tooltip title="Export to CSV">
                        <Button size="large" shape="circle" icon={<DownloadOutlined />} />
                    </Tooltip>
                </CSVLink>
            </div>
            <div>
                <Tooltip title="Clear all fields">
                    <Button size="large" shape="circle" icon={<DeleteOutlined />} onClick={clearForm} />
                </Tooltip>
            </div>
        </StickyFooter>
    );
};

export default ReducedFormActions;
